import {StripeCardElementOptions} from '@stripe/stripe-js';

const CARD_OPTIONS: StripeCardElementOptions = {
  style: {
    base: {
      iconColor: 'rgba(62,70,78,1)',
      color: 'rgba(62,70,78,1)',
      letterSpacing: '0.16px',
      fontSize: '16px',
      fontFamily: 'Avenir',
      fontWeight: '400',
      fontSmoothing: 'antialiased',
      ':-webkit-autofill': {
        color: '#000',
      },
      '::placeholder': {
        color: '#000',
      },
    },
    invalid: {
      iconColor: '#000',
      color: '#000',
    },
  },
};

export default CARD_OPTIONS